/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Each_Basic_Dachshund_ValueInputs */

const es_each_basic_dachshund_value = /** @type {(inputs: Each_Basic_Dachshund_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Privacidad`)
};

const gl_each_basic_dachshund_value = /** @type {(inputs: Each_Basic_Dachshund_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidade`)
};

const en_each_basic_dachshund_value = /** @type {(inputs: Each_Basic_Dachshund_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Each_Basic_Dachshund_ValueInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const each_basic_dachshund_value = /** @type {((inputs?: Each_Basic_Dachshund_ValueInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Each_Basic_Dachshund_ValueInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_each_basic_dachshund_value(inputs)
	if (locale === "en") return en_each_basic_dachshund_value(inputs)
	return es_each_basic_dachshund_value(inputs)
});